import styled, { css } from 'styled-components'

import { TypeStyle, fromMd, pageLayoutMaxWidthPixels, untilMd } from '@syconium/little-miss-figgy'

import { DetailsSectionSidePaddedSection } from '../../../components/pages/products/ProductPage/styles'

export const Container = styled.div`
  flex: 1;
  min-width: 256px;

  ${fromMd} {
    margin: 0 auto;
    max-width: 350px;
  }
`

export const Layout = styled.div`
  display: flex;
`

export const ReviewCountTextHeader = styled.span`
  ${TypeStyle.css.headlineMicro};
  color: #707070;
  font-weight: 600;

  u {
    color: ${o => o.theme.color.deprecated.obsidianLighter};
  }
`

export const ReviewBackground = styled.div`
  background: #f5f5f5;
  width: 100%;
`

export const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  padding: ${o => o.theme.spacing(5, 4)};

  ${fromMd} {
    padding: ${o => o.theme.spacing(10, 6)};
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: ${pageLayoutMaxWidthPixels}px;
  }
`

export const PaddedItem = styled.div`
  padding: 0;
`

export const ReviewCountText = styled.span`
  ${TypeStyle.css.headlineMicro};
  color: #707070;
  font-weight: 600;
  text-decoration: none;
`

export const TitleContainer = styled.div`
  display: flex;
  margin-bottom: ${o => o.theme.spacing(2)};
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: 1.5px;
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const TitleSection = styled(DetailsSectionSidePaddedSection)`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const Title = styled(TypeStyle.HeadlineSmall)`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;

  ${fromMd} {
    -webkit-line-clamp: unset;
  }
`

export const ReviewHeader = styled.div`
  display: flex;
  width: 902px;
  max-width: 100%;
  justify-content: space-between;
  margin-top: 0px;

  ${untilMd} {
    width: auto;
  }
`

export const ReviewRatingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 902px;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: solid 1px #e6e6e6;
  border-radius: 4px;
  padding: ${o => o.theme.spacing(6, 0, 6, 0)};
  margin-top: ${o => o.theme.spacing(8)};
  box-sizing: border-box;
  margin-bottom: ${o => o.theme.spacing(4)};

  ${untilMd} {
    width: 343px;
    margin-bottom: 0;
    margin-top: ${o => o.theme.spacing(4)};
  }
`

export const ReviewItem = styled.div`
  width: 902px;
  max-width: 100%;
  background: #ffffff;
  border: solid 1px #e6e6e6;
  border-radius: 4px;
  margin-bottom: ${o => o.theme.spacing(4)};
  box-sizing: border-box;

  ${untilMd} {
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 343px;
  }
`

export const ReviewTitle = styled(TypeStyle.HeadlineSmall)`
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const ReviewStarIconContainerHeader = styled.div<{ isVisible: boolean }>`
  display: flex;
  margin-inline-end: 8px;
  visibility: ${props => (props.isVisible ? 'inherit' : 'hidden')};

  ${untilMd} {
    margin-inline-end: 5px;
  }
`

export const ReviewTitleButtonWrapper = styled.div`
  ${untilMd} {
    display: none;
  }
`

export const ButtonWrapperMobile = styled.div`
  display: flex;
  justify-content: center;
  margin: ${o => o.theme.spacing(8, 0, 23.5, 0)};

  ${untilMd} {
    width: 343px;
    margin: ${o => o.theme.spacing(0, 0, 4, 0)};
  }
  ${fromMd} {
    display: none;
  }
`

export const ReviewStarContainerHeader = styled.a`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  width: fit-content;
  position: relative;

  ${untilMd} {
    margin: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
  }
`

export const ReviewAverageScore = styled.p`
  font-size: 36px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.05em;
  font-style: normal;
  color: ${o => o.theme.color.deprecated.obsidian};

  ${untilMd} {
    font-size: 25px;
  }
`

export const ButtonWrapperFooter = styled.div`
  margin: ${o => o.theme.spacing(4, 0, 23.5, 0)};

  ${untilMd} {
    margin: ${o => o.theme.spacing(6, 0, 6, 0)};
  }
`
export const ButtonWrapper = styled.div`
  > button {
    border-color: ${o => o.theme.color.deprecated.gray.dark};
    color: ${o => o.theme.color.deprecated.gray.dark};

    &:hover {
      border-color: black;
    }
  }
  box-sizing: border-box;
  padding: ${o => o.theme.spacing(4, 8)};
  box-sizing: border-box;
  border: solid 2px #282828;
  border-radius: 4px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;

  &:hover {
    background: #e5e5e5;
  }

  ${fromMd} {
    width: 200px;
  }

  ${untilMd} {
    width: 343px;
  }
`

export const ReviewButton = styled.button`
  ${TypeStyle.css.headlineMicro};
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1.8px;
`

export const ButtonText = styled.span`
  color: ${o => o.theme.color.deprecated.obsidian};

  &:hover {
    color: ${o => o.theme.color.deprecated.obsidianLight};
  }
`

export const ReviewStarIconContainer = styled.div`
  display: flex;
  margin-right: 0px;

  ${untilMd} {
    margin-top: ${o => o.theme.spacing(2)};
    margin-right: 0px;
  }
`

export const ReviewCountTextContainer = styled.div<{ isVisible: boolean }>`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  visibility: ${props => (props.isVisible ? 'inherit' : 'hidden')};
`

export const ReviewCountTextContainerBody = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: ${o => o.theme.spacing(4)};

  ${untilMd} {
    margin-top: ${o => o.theme.spacing(2)};
  }
`

export const ProductDetailsCopy = styled.blockquote<{ secondary?: boolean }>`
  ${TypeStyle.css.headlineMicro}
  color: ${o => o.secondary && o.theme.color.deprecated.obsidianLighter};
`

export const ReviewStars = styled.div<{ rating: number; isLarge?: boolean }>`
  display: inline-block;
  font-family: Times;
  font-size: ${o => (o.isLarge ? '16px' : '13px')};
  line-height: 1;

  &::before {
    ${o => {
      const percentage = `${(o.rating / 5) * 100}%`
      return css`
        background: linear-gradient(
          90deg,
          currentColor ${percentage},
          ${o.theme.color.deprecated.stoneLight} ${percentage}
        );
      `
    }}

    background-clip: text;
    -webkit-background-clip: text;
    content: '★★★★★';
    letter-spacing: 3px;
    -webkit-text-fill-color: transparent;
  }

  .rtl & {
    transform: scaleX(-1);
  }
`

export const ReviewPhotosWrapper = styled.div`
  max-width: 100%;
  width: 343px;
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  margin-top: ${o => o.theme.spacing(4)};
  margin-bottom: ${o => o.theme.spacing(6)};
  padding-bottom: ${o => o.theme.spacing(6)};

  ${fromMd} {
    width: 902px;
    margin-top: 0px;
  }
`
